import React, {useEffect, useState} from 'react';
import IssuanceWarehouseMaterialTable
    from "../../../components/UI/table/prodaction/issue/IssuanceWarehouseMaterialTable";
import IssuanceService from "../../../API/orders/prodaction.issueedge/issuance/IssuanceService";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import {Box} from "@mui/system";
import Typography from "@mui/material/Typography";
import {constantsErrorMessages} from "../../../Constants";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import dayjs from "dayjs";
import DateTimeUtil from "../../../utils/common/DateTimeUtil";

const AllIssuanceMaterialReserve = () => {
    const [data, setData] = useState([]);
    const profile = JSON.parse(localStorage.getItem("profile"))
    const {baseCurAbbreviation: baseCurrency, alternativeCurAbbreviation: alternativeCurrency} = profile
    const [unableAfterCut, setUnableAfterCut] = useState({});
    const [alertData, setAlertData] = useState({});
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const startIssueInitValue = dayjs().date(1)

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData("organization/issuance-material-reserve", "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData["organization/issuance-material-reserve"]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    const getData = (startIssue, finishIssue, startWrittenOff, finishWrittenOff) => {
        IssuanceService.getAllWithFilter(tableOptions.pageIndex, tableOptions.pageSize, startIssue, finishIssue, startWrittenOff, finishWrittenOff).then(function (response) {
            const data = response.data.content;
            setTableOptions((prev) => ({...prev, totalElements: response.data.total}))
            setData(data);
            data.forEach((row) => {
                unableAfterCut[row.id] = row.afterCut;
            });
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }

    useEffect(() => {
        getStartPageSize()
    }, []);

    useEffect(() => {
        getData(DateTimeUtil.convertToJavaDateTime(startIssueInitValue))
    }, [tableOptions.pageIndex, tableOptions.pageSize]);

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Выдачи"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Выдачи
                    </Typography>
                </Box>
                <IssuanceWarehouseMaterialTable
                    data={data}
                    setData={setData}
                    baseCurrency={baseCurrency}
                    alternativeCurrency={alternativeCurrency}
                    unableAfterCut={unableAfterCut}
                    setUnableAfterCut={setUnableAfterCut}
                    afterCut={true}
                    handleModalAlert={handleModalAlert}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    getData={getData}
                    startIssueInitValue={startIssueInitValue}
                    withFilter={true}
                />
            </Box>
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default AllIssuanceMaterialReserve;